import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import ItemView from "./ItemView";

export default class ExampleItemView extends ItemView {
    constructor(target) {
        super(target);
    }


    set content(skin) {
        super.content = skin;
        this._addOutline();
    }

    _addOutline() {
        const skin = this._content;
        if (skin) {
            const radius = 8;
            const steps = Math.round(radius * 3);
            skin.gotoAndStop(0);
            const bmp = skin.getChildAt(0);
            const outline = skin.addChildAt(new createjs.Container(), 0);
            for (let a = 0; a < Math.PI * 2; a += Math.PI * 2 / steps) {
                const dx = Math.cos(a) * radius;
                const dy = Math.sin(a) * radius;
                const clone = bmp.clone();
                outline.addChildAt(clone, 0);
                clone.x += dx;
                clone.y += dy;
            }
            outline.filters = [
                new createjs.ColorFilter(0, 0, 0, 1, 0x28, 0x25, 0x26, 0)
            ];
            const margin = radius + 2;
            //cache outline to apply filter
            CacheUtil.cache(outline, margin, margin);
            //cache total skin for performance
            CacheUtil.cache(skin, margin, margin);
        }
    }
}